import { useState, useMemo, useEffect } from 'react';

const useServerProps = (ssrProps) => {
	const initialServerProps = useMemo(() => {
		if(ssrProps) {
			return { isServer: true, ...ssrProps };
		}
		else {
			const windowServerProps = {isServer: false, ...window.serverProps};
			
			return windowServerProps;
		}
	}, [ssrProps])

	const [serverProps, setServerProps] = useState(initialServerProps);

	useEffect(() => {
		const injectorElem = document.getElementById('server-props-injector');
		setTimeout(() => {
			if(injectorElem) {
				setServerProps({
					...window.serverProps,
					cookies: {},
					initialRoute: {},
					pageProps: {}
				});
				injectorElem.remove();
				window.serverProps = null;
			}
		}, 1000)
	}, [])

	return serverProps;
}

export default useServerProps